<div class="popular-bets-bet-builder-plus-pod-header">
    <ng-template #badgeContainer />
    <div class="popular-bets-bet-builder-plus-pod-header__event-name" [style.color]="titleColor()">
        {{ eventTitle() }}
    </div>
</div>
<div class="popular-bets-bet-builder-plus-pod-header__event-date">
    @if (pod().eventStartDate; as eventStartDate) {
        <ms-event-timer [start]="eventStartDate" [isDynamicTimer]="false" [style.color]="titleColor()" />
    }
</div>
